export default __webpack_public_path__ + "static/media/algo-white.5a3d1497.png";